import {productBoxWideSettings, ProductBoxWideSettings} from '../../../bps/components/productBoxWide/productBoxWideSettings';

productBoxWideSettings.flags = {
  whitelistImage: ['free', 'savings', 'award', 'new', 'newVintage', 'exclusiveText', 'bio'],
  whitelistTag: ['nonAlcoholic', 'vegan'],
  whitelistConversion: [],
};
productBoxWideSettings.rating.type = 'text';
productBoxWideSettings.readMoreLink = true;
productBoxWideSettings.personalisationTop = true;

export {productBoxWideSettings, ProductBoxWideSettings};
